import React, { useCallback } from "react";
import {
  Text,
  View,
  ScrollView,
  Platform,
  useWindowDimensions,
  Image,
} from "react-native";
import {
  isActionTabsLayout,
  isOpaqueStripeDisabled,
  ScreenNameList,
} from "@lib/utilities/Constants";
import { styles, ids } from "./style";
import Banner from "../../components/common/Banner";
import { withPolicyDataFetching } from "../../hoc/withFetchPolicyData";
import { usePolicyActions } from "@lib/hooks/policyScreen/usePolicyActions";
import ActionTiles from "../../components/ActionTile/ActionTilesContainer";
import { Header } from "../../components/header/Header";
import { isTablet } from "react-native-device-info";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { description } from "../../resources/strings";
import MainContainer from "../../components/common/MainContainer";
import { POLICY_ACTION_BG } from "../../resources/IMAGES";
import { theme } from "src/theme/theme";

const PolicyActions = ({ policyData, route, navigation }: any) => {
  const {
    banner,
    errorHandle,
    bannerCloseAction,
    onEndTimer,
    onReloadPress,
    navigationToInnerScreens,
    isActionTabs,
  } = usePolicyActions(policyData, navigation, route);
  const { height, width } = useWindowDimensions();
  const isPortrait = height > width;
  const BannerContainer = () => {
    return (
      <View
        style={styles.bannerContainer}
        dataSet={{ media: ids.bannerContainer }}
      >
        {banner && (
          <Banner
            banner={banner}
            onItemPress={() => {
              bannerCloseAction();
            }}
          />
        )}
      </View>
    );
  };

  const getOrientationStyle = () => {
    if (!isTablet() || Platform.OS == "web") {
      return {};
    }
    return {
      ...Platform.select({
        ios: {
          height: isPortrait ? height : height * 1.3,
          width: width,
          marginLeft: isPortrait || isActionTabsLayout() ? 0 : height * 0.02,
          top: 100,
        },
        android: {
          height: isPortrait ? height : height * 1.4,
          width: width,
          marginLeft: isPortrait ? 0 : height * 0.02,
          top: 0,
        },
      }),
    };
  };

  const ActionTabsContainer = () => {
    return (
      <View
        style={[
          styles.fullWidth,
          {
            ...Platform.select({
              web: {},
              android: {
                marginTop: isTablet()
                  ? height > width
                    ? -height * 0.07
                    : -width * 0.07
                  : -theme.margin.xlg,
              },
              ios: {
                marginTop: isActionTabsLayout() ? -theme.margin.xlg : 0,
                marginBottom: "10%",
              },
            }),
          },
        ]}
      >
        <ScrollView
          bounces={false}
          style={{
            ...Platform.select({
              web: {
                minHeight: height,
              },
            }),
          }}
          showsHorizontalScrollIndicator={false}
          // scrollEnabled={Platform.OS == "web" ? false : true}
          contentContainerStyle={{
            flexGrow: 1,
          }}
        >
          <View style={styles.actionTabContainer}>
            <View style={styles.allCenter}>
              <Image
                resizeMode="cover"
                source={POLICY_ACTION_BG}
                style={[
                  styles.coverImage,
                  {
                    ...Platform.select({
                      ios: {
                        height: isTablet()
                          ? height > width
                            ? height / 2.7
                            : width / 2.7
                          : height / 3,
                      },
                      android: {
                        height: isTablet()
                          ? height > width
                            ? height / 2.7
                            : width / 2.7
                          : height / 3,
                      },
                    }),
                  },
                ]}
              />
              <View style={[styles.allCenter, { position: "absolute" }]}>
                <Text
                  style={styles.textHeading}
                  dataSet={{ media: ids.textHeading }}
                >
                  {description.action.description1}
                </Text>
                <Text
                  style={styles.textSubHeading}
                  dataSet={{ media: ids.textSubHeading }}
                >
                  {description.action.description2}
                </Text>
              </View>
            </View>
            <ActionTiles
              navigation={navigation}
              navigationToInnerScreens={navigationToInnerScreens}
              variant="actionTabs"
            />
          </View>
        </ScrollView>
      </View>
    );
  };
  const ActionTileContainer = () => {
    return (
      <View
        style={[styles.policyActions]}
        dataSet={{ media: ids.policyActions }}
      >
        <View style={styles.headerInfo} dataSet={{ media: ids.headerInfo }}>
          <Text
            style={styles.heading}
            dataSet={{ media: ids.heading }}
            testID="action-page-header-label"
          >
            {description.action.description1}
          </Text>
          <View style={{ flex: 1 }}>
            <Text
              style={styles.subHead}
              dataSet={{ media: ids.subHead }}
              testID="action-page-description-label"
            >
              {description.action.description2}
            </Text>
          </View>
        </View>

        <ActionTiles
          navigation={navigation}
          navigationToInnerScreens={navigationToInnerScreens}
        />
      </View>
    );
  };
  const PolicyActionContent = () => (
    <View style={{ height: "100%" }}>
      <ScrollView
        bounces={false}
        showsVerticalScrollIndicator={false}
        style={[
          styles.viewContainer,
          {
            ...Platform.select({
              android: {
                marginTop: isTablet() ? 0 : -70,
                paddingLeft: isTablet() || isActionTabsLayout() ? 0 : 20,
              },
              web: {
                paddingTop: isActionTabsLayout() ? 10 : 60,
              },
            }),
          },
        ]}
        dataSet={{ media: ids.viewContainer }}
      >
        <View
          style={[
            styles.container,
            !isActionTabsLayout() && getOrientationStyle(),
          ]}
          dataSet={{ media: ids?.container }}
        >
          {isActionTabs ? <ActionTabsContainer /> : <ActionTileContainer />}
        </View>
      </ScrollView>
    </View>
  );
  const PolicyActionContainer =
    Platform.OS == "web" || isTablet()
      ? useCallback(() => <PolicyActionContent />, [])
      : () => <PolicyActionContent />;

  return (
    <MainContainer
      screenName={ScreenNameList.policyActions}
      navigation={navigation}
      errorData={{
        message: errorHandle,
        screenName: ScreenNameList.policyActions,
      }}
      onReloadPress={onReloadPress}
      onEndTimer={onEndTimer}
    >
      <View
        style={[styles.containerFluid]}
        dataSet={{ media: ids.containerFluid }}
      >
        {!isOpaqueStripeDisabled && (
          <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
        )}
        <Header
          screenName={ScreenNameList.policyActions}
          navigation={navigation}
        />

        <BannerContainer />

        <PolicyActionContainer />

        {!isOpaqueStripeDisabled && (
          <View
            style={[styles.bgEffectBottom]}
            dataSet={{ media: ids.bgEffectBottom }}
          />
        )}
      </View>
    </MainContainer>
  );
};

export default Platform.OS == "web"
  ? withAuthenticationRequired(withPolicyDataFetching(PolicyActions))
  : withPolicyDataFetching(PolicyActions);
